<template>

  <div class="col-xxl-12">
      <MyProspectsList
        widget-classes="card-xxl-stretch mb-5 mb-xxl-8"
      ></MyProspectsList>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import MyProspectsList from "@/components/myprospects/MyProspectsList.vue";

export default defineComponent({
  name: "packagepoints",
  components: {
    MyProspectsList
  },
  setup() {
    const tabIndex = ref(0);

   

    onMounted(() => {
      // set the tab from previous
      tabIndex.value = parseInt(localStorage.getItem("myProspectsTab") || "0");
    });

  }
});
</script>
